import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import {
    FiCloudRain,
    FiClock,
    FiAlertTriangle,
    FiEye,
    FiCloudOff,
} from 'react-icons/fi';

const SUMMARY_CARDS = [
    {
        key: 'forecast_total',
        section: 'forecast',
        label: 'Forecast total',
        icon: FiCloudRain,
        iconClass: 'text-primary',
    },
    {
        key: 'forecast_pending_check',
        section: 'forecast',
        label: 'En attente de check',
        icon: FiClock,
        iconClass: 'text-warning',
    },
    {
        key: 'forecast_triggered',
        section: 'forecast',
        label: 'Forecast déclenchés',
        icon: FiAlertTriangle,
        iconClass: 'text-danger',
    },
    {
        key: 'observation_claims_total',
        section: 'observation_claims',
        label: 'Obs. sinistres total',
        icon: FiEye,
        iconClass: 'text-secondary',
    },
    {
        key: 'observation_claims_pending',
        section: 'observation_claims',
        label: 'Obs. sinistres en attente',
        icon: FiClock,
        iconClass: 'text-warning',
    },
    {
        key: 'observation_forecast_not_triggered_total',
        section: 'observation_fnt',
        label: 'Obs. non déclenchés',
        icon: FiCloudOff,
        iconClass: 'text-secondary',
    },
];

const DashboardSummaryCards = ({ summary, onCardClick }) => {
    if (!summary) return null;

    return (
        <Row className="g-3 mb-4">
            {SUMMARY_CARDS.map((card) => {
                const Icon = card.icon;
                const value = summary[card.key] ?? 0;

                return (
                    <Col key={card.key} xs={6} md={4} xl={2}>
                        <Card
                            className="admin-ds-section-card h-100 ops-kpi-card"
                            role="button"
                            tabIndex={0}
                            onClick={() => onCardClick?.(card.section)}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    event.preventDefault();
                                    onCardClick?.(card.section);
                                }
                            }}
                            aria-label={`${card.label} : ${value}`}
                        >
                            <Card.Body className="text-center py-3">
                                <div className={`ops-kpi-card__icon mb-2 ${card.iconClass}`}>
                                    <Icon size={20} />
                                </div>
                                <div className="fs-4 fw-bold text-dark">{value}</div>
                                <div className="text-muted small">{card.label}</div>
                            </Card.Body>
                        </Card>
                    </Col>
                );
            })}
        </Row>
    );
};

export default DashboardSummaryCards;
